import { InvoiceDiscount, InvoiceTaxRate, useInvoice } from '@melio/ar-domain';

import { ServiceChargeParams } from '../../../types';
import { useGetUpdatePayload } from './line-item-utils';
import { InvoiceFormValues } from './useInvoiceForm';

type EditInvoiceActionsProps = {
  invoiceId: string;
  discount?: InvoiceDiscount;
  taxRate?: InvoiceTaxRate;
  serviceCharges?: ServiceChargeParams[];
  onError?: ErrorFunction;
};

export const useEditInvoiceActions = ({
  invoiceId,
  discount,
  serviceCharges,
  taxRate,
  onError,
}: EditInvoiceActionsProps) => {
  const { update, isMutating: isSaving } = useInvoice({ id: invoiceId, enabled: false, onUpdateError: onError });
  const getPayloadFromFormData = useGetUpdatePayload({ onError });
  const updateInvoice = (formData: InvoiceFormValues) => {
    const payload = getPayloadFromFormData({ data: formData, discount, serviceCharges, taxRate });
    return update(payload);
  };
  return {
    updateInvoice,
    isSaving,
  };
};
